// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-template/src/index.tsx

import baseIcon, { defaultIconGroupProps } from '@bubble-ui/temp-icon-base';
var IconLocationPath = 'M10 .04c-4.219 0-7.65 3.432-7.65 7.65 0 1.713.547 2.902.575 2.95.544 1.451 5.346 7.246 6.303 8.392l.766.919.77-.918c.957-1.147 5.767-6.942 6.276-8.311.063-.13.61-1.319.61-3.032 0-4.218-3.43-7.65-7.65-7.65Zm5.202 9.897c-.256.685-2.725 3.878-5.206 6.888-2.477-3.011-4.945-6.211-5.233-6.97-.004-.008-.413-.894-.413-2.165A5.657 5.657 0 0 1 10 2.04a5.657 5.657 0 0 1 5.65 5.65c0 1.23-.389 2.112-.444 2.238l-.004.009ZM10 4.04c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5 3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5Zm0 5c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5 1.5.673 1.5 1.5-.673 1.5-1.5 1.5Z';
var IconLocation = baseIcon('IconLocation', {
  groupProps: defaultIconGroupProps,
  getPath: () => IconLocationPath
});
export default IconLocation;
//# sourceMappingURL=index.js.map